<template>
  <div>
    <v-btn
      v-if="!schema.readonly"
      @click="onUploadFileClicked"
      color="blue-grey"
      class="white--text"
    >
      {{$t('Выбрать файл')}}
      <v-icon right dark>mdi-cloud-upload</v-icon>
    </v-btn>
    <input
      style="display:none"
      type="file"
      @change="handleFiles"
      accept="*"
      ref="uploadRef"
      multiple
    />
    <div class="uploadedItem" v-for="(file,index) in value" :key="index">
      <label>{{file.name}}</label>

      <v-btn
        class="icon-btn"
        @click="onShowClicked(file)"
        :title="$t('Открыть')"
        flat
        icon
        color="primary"
      >
        <v-icon>mdi-eye</v-icon>
      </v-btn>
      <v-btn
        class="icon-btn"
        v-if="file.id"
        @click="saveFile(file.name,file.id)"
        :title="$t('Загрузить')"
        flat
        icon
        color="primary"
      >
        <v-icon>mdi-cloud-download</v-icon>
      </v-btn>
      <v-btn
        class="icon-btn"
        v-if="!schema.readonly"
        @click="deleteFile(file)"
        :title="$t('Удалить')"
        flat
        icon
        color="primary"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </div>
    <div class="error-files-container">
      <p
        class="error-files"
        v-for="(notValidFile,i) in notValidFiles"
        :key="i"
      >{{notValidFile.name+" "+notValidFile.error}}</p>
    </div>

    <v-layout justify-center>
      <v-dialog
        v-if="value && value.length > 0"
        v-model="showFile"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <v-card id="viwer-container">
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="showFile = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{currentShownFile.name}}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <file-viewer v-bind:file-data="currentShownFile.data"></file-viewer>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import FileMixin from '@/mixins/FileMixin';
import FileViewer from '../components/FileViewer';

export default {
    components: { FileViewer },
    mixins: [abstractField, FileMixin],
    data() {
        return {
            files: [],
            notValidFiles: [],
            showFile: false,
            currentShownFile: {}
        };
    },
    methods: {
    async handleFiles(e) {

  const prev = Array.isArray(this.value) ? this.value.slice() : [];


  if (FileMixin && FileMixin.methods && typeof FileMixin.methods.handleFiles === 'function') {
    const maybePromise = FileMixin.methods.handleFiles.call(this, e);
    if (maybePromise && typeof maybePromise.then === 'function') {
      await maybePromise;
    }
  } else {

    const list = Array.from((e && e.target && e.target.files) ? e.target.files : []);
    const items = await Promise.all(list.map(f => new Promise(resolve => {
      const r = new FileReader();
      r.onload = () => resolve({ name: f.name, id: null, data: r.result, _file: f });
      r.onerror = () => resolve({ name: f.name, id: null, data: null, _file: f });
      r.readAsDataURL(f);  
    })));
    this.value = items; 
  }

 
  const next = Array.isArray(this.value) ? this.value : [];
  const seen = new Set(
    prev.map(it =>
      it.id
        ? `srv:${it.id}`
        : it._file
          ? `loc:${it._file.name}:${it._file.size}:${it._file.lastModified}`
          : `srvname:${it.name}`
    )
  );

  const merged = prev.concat(
    next.filter(it => {
      const key = it.id
        ? `srv:${it.id}`
        : it._file
          ? `loc:${it._file.name}:${it._file.size}:${it._file.lastModified}`
          : `srvname:${it.name}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
  );


  this.value = merged;


  if (this.$refs.uploadRef) this.$refs.uploadRef.value = '';
},
        onUploadFileClicked() {
            this.$refs.uploadRef.click();
        },
        async onShowClicked(file) {
            if (file.name.match(/\.(jpeg|jpg|gif|png|bmp|tif|tiff)$/) != null) {
                if (file.data) {
                    this.currentShownFile = file;
                    this.showFile = true;
                } else {
                    let fileData = await this.downloadFileLocal(file.id);
                    if (fileData) {
                        file.data = fileData;
                        this.currentShownFile = file;
                        this.showFile = true;
                    } else {
                        //ошибка загрузки
                    }
                }
            } else {
                //не изображение
                if (file.id) {
                    //файл еще загружен
                    this.saveFile(file.name, file.id);
                }
            }
        }
    },

    mounted() {}
};
</script>

<style>
.uploadedItem {
    padding: 10px;
    padding-bottom: 0px;
}
.uploadedItem .v-btn {
    padding: 0 !important;
    border: none !important;
    border-radius: 30px !important;
}
.uploadedItem > label {
    margin-right: 5px;
    max-width: 152px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    vertical-align: middle;
}
.icon-btn {
    margin-right: 0px !important;
}

#viwer-container {
    background-color: transparent !important;
}
.error-files {
    color: red;
    margin-bottom: 5px;
    font-size: 13px;
    max-width: 250px;
}
.error-files-container {
    padding-top: 5px;
}
</style>